
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>회원 관리 - 회원 현황</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 삭제는 안되며 수정 버튼을 통해 사용 여부를 미사용으로 활용하면 됩니다.</p>
          </div>

          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_customer
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminCustomerManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `
        /AdminCustomerManagementAdd?customer_ID=${this.tabulator.getSelectedData()[0].customer_ID}
        &customer_login_ID=${this.tabulator.getSelectedData()[0].customer_login_ID}
        `
      }
    }
  },
  mounted () {
    get_customer().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        pagination: 'local', // 로컬 데이터를 기준으로 페이징 처리
        paginationSize: 10, // 한 페이지에 표시할 행 수
        paginationSizeSelector: [5, 10, 20, 50], // 사용자가 선택할 수 있는 페이지 크기 옵션
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'customer_ID', headerSort: false},
          {title: '가입구분', field: 'customer_division', headerSort: false},
          {title: '로그인 ID', field: 'customer_login_ID', headerSort: false},
          {title: '고객명', field: 'customer_name', headerSort: false},
          {title: '전화번호', field: 'customer_phone_number', headerSort: false},
          {title: '이메일', field: 'customer_email', headerSort: false},
          {title: '성별', field: 'customer_gender', headerSort: false},
          {title: '사용여부', field: 'customer_activate', headerSort: false},
          {title: '등록 일자', field: 'customer_registe', headerSort: false},
          {title: '수정 일자', field: 'customer_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CustomerManagement/AdminCustomerManagement.vue